const apiPath = {
  development: '', // 开发环境api地址
  production: 'http://192.168.1.74:8000', // 生产环境api地址
};

const isPro = true;
const serviceApi = isPro ? 'https://zhfw.zyjkfw.cn' : 'http://smarthse.51vip.biz:8456';

const uploadApis = '/v2/admin/uploadFile';
const serverUploadApi = '/v2/www/api/file/upload';
const adminUploadApi = '/v3/admin/api/file/upload';
const adminUploadVideoApi = '/v3/admin/api/file/upload/m3u8';
export {
  apiPath,
  uploadApis,
  serverUploadApi,
  adminUploadApi,
  serviceApi,
  isPro,
  adminUploadVideoApi,
};
